<template>
	<div>

		<NavMenu v-if="navType == 'MENU'" />
		<NavLogo v-if="navType == 'NO_MENU'" />

	</div>

</template>

<script>
	import NavLogo from './nav-logo.vue';
	import NavMenu from './nav-menu.vue';
	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';

	export default {
		name: 'navigation',
		mixins: [sharedEnvMixin],
		components: {
			NavLogo,
			NavMenu,
		},
		data() {
			return {};
		},
		methods: {},
	};
</script>
